import Transferencia from '../../spa/orcamento/transferencia/Transferencia';
import TransferenciaForm from '../../spa/orcamento/transferencia/TransferenciaForm';

export default {
  path: 'transferencia',
  name: 'transferencia',
  component: Transferencia,
  children: [
    {
      path: 'nova',
      name: 'novaTransferencia',
      component: TransferenciaForm,
      props: {
        fluxo: false,
        somenteLeitura: false,
        novo: true,
      },
    },
    {
      path: ':id',
      name: 'verTransferencia',
      component: TransferenciaForm,
      props: {
        somenteLeitura: true,
        novo: false,
        fluxo: false,
      },
    },
    {
      path: ':id/fluxo',
      name: 'verTransferenciaFluxo',
      component: TransferenciaForm,
      props: {
        somenteLeitura: true,
        novo: false,
        fluxo: true,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/transferencia.js